// utils.js
import * as luxon from "luxon";

const shared = {
  formatDate: function (dateString) {
    return luxon.DateTime.fromISO(dateString).toFormat("dd/MM/yyyy HH:mm");
  },
  formatDateWithoutHours: function (dateString) {
    return luxon.DateTime.fromISO(dateString).toFormat("dd/MM/yyyy");
  },
  moneyConfig: function () {
    return {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: "",
      precision: 2,
      masked: false,
      modelModifiers: {
        number: true,
      },
    };
  },
  formatCurrency: function (value) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  },
  percentageConfig: function () {
    return {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: "",
      precision: 2,
      masked: false,
      modelModifiers: {
        number: true,
      },
    };
  },
  returnAssetType(id, assetTypes) {
    return assetTypes.find((type) => type.value === id);
  },
  formatMonthYear: function (dateString) {
    return luxon.DateTime.fromISO(dateString).toFormat("MM/yyyy");
  },
};

export default shared;
